import { Box, Paper, Popover, styled } from '@mui/material';

import { palette } from '../../../../../theme';
export const OptionIconSelectorBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'hasError'
})<{ hasError?: boolean }>(({ hasError, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  // it behaves as a field, so it gets a field's outline
  border: `1px solid ${hasError ? theme.palette.error.main : theme.palette.field.border}`,
  borderRadius: '8px',
  padding: '6px 10px',
  cursor: 'pointer',
  width: 'fit-content',
  backgroundColor: palette.surface.main,
  '&:hover': {
    borderColor: hasError ? theme.palette.error.main : theme.palette.field.hover
  }
}));

export const PlaceholderIconOptionBox = styled(Box)(({ theme }) => ({
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: palette.text.placeholder,
  borderRadius: '8px',
  fontSize: 12
}));

export const IconOptionBox = styled(Box)({
  width: 32,
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: palette.line
  }
});
export const IconPopover = styled(Popover)({
  '& .MuiPaper-root': {
    marginTop: 8,
    padding: 8,
    width: 140,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 8
  }
});
